import Vue from 'vue'
import Vuex from 'vuex'
import { db } from '../main'
import firebase from 'firebase/app'
import 'firebase/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    userProfile: null, // { balance: 0, clickHistory: [] }
    balance: 0.00
  },
  getters: {
    user(state) {
      return state.user;
    },
    isAuthenticated(state) {
      return !!state.user;
    },
    balance(state) {
      return state.balance;
    }
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    setUserProfile(state, payload) {
      state.userProfile = payload;
      if (payload && payload.balance) {
        state.balance = payload.balance;
      }
    },
    clearUser(state) {
      state.user = null;
      state.userProfile = null;
      state.balance = 0.00;
    }
  },
  actions: {
    async fetchUserProfile({ commit, state }) {
      if (!state.user) return;

      try {
        const doc = await db.collection('Users').doc(state.user.uid).get();
        if (doc.exists) {
          commit('setUserProfile', doc.data());
        } else {
          // Create default profile if not exists
          const defaultProfile = {
            balance: 0.00,
            createdAt: new Date(),
            email: state.user.email,
            role: 'user'
          };
          await db.collection('Users').doc(state.user.uid).set(defaultProfile);
          commit('setUserProfile', defaultProfile);
        }
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    },
    async login({ dispatch }, { email, password }) {
      // Placeholder for future action if we move auth logic here
    },
    async logout({ commit }) {
      await firebase.auth().signOut();
      commit('clearUser');
    }
  }
});
